'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { converters } from '@/lib/converters';
import { PopularConversions } from './PopularConversions';
import { getUsageData } from '@/lib/dataService';

interface ConversionUsage {
  from: string;
  to: string;
  count: number;
}

interface PopularConversionsCardProps {
  popularConversions?: ConversionUsage[];
}

export function PopularConversionsCard({ popularConversions: initialData }: PopularConversionsCardProps) {
  const [popularConversions, setPopularConversions] = useState<ConversionUsage[]>(initialData || []);

  useEffect(() => {
    // Only fetch data on client side
    if (typeof window !== 'undefined') {
      const usageData = getUsageData();
      const conversions = Object.entries(usageData)
        .map(([key, count]) => {
          const [from, to] = key.split('-');
          return { from, to, count };
        })
        .sort((a, b) => b.count - a.count)
        .slice(0, 15);
      
      setPopularConversions(conversions);
    }
  }, []);

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4">
      <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
        Popular Conversions
      </h2>
      <PopularConversions popularConversions={popularConversions} />
    </div>
  );
}
